import { enClientPortalValueCheckPageLayout } from './ValueCheck/ValueCheckLayout/ValueCheckPageLayout'

export const enClientPortalValueCheckPages = {
    valueCheckPageLayout: enClientPortalValueCheckPageLayout,
}
